module.exports = __webpack_public_path__ + "static/media/template4.ffaf6237.png";